import React from 'react';
import { SearchBoxTitleComponent } from '../search-box-title/search-box-title.component';
import { ISearchSuggestion } from '../../../../services/game-search/game-search-result';
import { observer } from 'mobx-react';
import { SearchGamesListBox } from "./boxes/search-games-list/search-games-list.box";
import { SearchNoGamesFoundBox } from "./boxes/search-no-game-found/search-no-games-found.box";
import { CyClass } from "../../../../../common/cy-classes";
import { SearchGameItemComponent } from '../search-game-item/search-game-item.component';
import { SuggestedGamesComponent } from '../suggested-games/suggested-games.component';
import { Button } from '../../../../basic-ui-components/button/base/button.component';
import { MoreGamesBox } from './boxes/more-games/more-games.box';
import {ComponentServicesPick} from "../../../../services/component-services-pick";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {withServices} from "../../../../react-hooks/with-services";

interface FoundGamesComponentProps extends ComponentServicesPick<'gameSearch'> {
    loadedGamesCount: number;
    onLoadMore: () => void;
}

const ComponentBody: React.FC<FoundGamesComponentProps> = observer((props) => {
    const services = useServices();
    const _renderGame = (suggestedGame: ISearchSuggestion) => {
        return (
            <SearchGameItemComponent key={suggestedGame.key} searchSuggestion={suggestedGame} />
        );
    }

    const hasMoreItems = props.loadedGamesCount < props.gameSearch.searchResult.games.length;

    const _renderMoreGames = () => {
        if (services.device.os.isPC) {
            return null;
        }

        return (
            <MoreGamesBox shouldDisplay={hasMoreItems} className={CyClass('cy-found-games-more-box')}>
                <Button
                    className={CyClass('cy-found-games-more')}
                    active
                    fullWidth
                    preset="flatStroked"
                    sizeVariant="xs"
                    noRemUnits
                    disabled={!hasMoreItems}
                    onClick={props.onLoadMore}
                >
                    {services.translation.translate("MORE")}
                </Button>
            </MoreGamesBox>
        );
    }

    const _renderFoundGames = () => {
        const gamesToRender = Math.min(props.loadedGamesCount, props.gameSearch.searchResult.games.length);
        return (
            <SearchGamesListBox className={CyClass('cy-found-games-list-box')}>
                {props.gameSearch.searchResult.games.slice(0, gamesToRender).map(suggestedGame => _renderGame(suggestedGame))}
                {_renderMoreGames()}
            </SearchGamesListBox>
        );
    }

    const _renderNoSearchResultMessage = () => {
        return (
            <>
                <SearchNoGamesFoundBox className={CyClass('cy-no-found-games-box')}>
                    {services.translation.translate('NO_SEARCH_RESULTS')}
                </SearchNoGamesFoundBox>

                <SuggestedGamesComponent items={props.gameSearch.searchResult.suggestedGames} />
            </>
        );
    }

    return (
        <div className={'cy-search-results'}>
            <SearchBoxTitleComponent title={'SEARCH_RESULTS_TITLE'} numberOfResults={props.gameSearch.searchResult?.games?.length}/>
            { props.gameSearch.searchResult?.games?.length > 0 ?
                _renderFoundGames() :
                _renderNoSearchResultMessage()
            }
        </div>
    );
})

export const FoundGamesComponent = withServices(ComponentBody, ['gameSearch']);